import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";


@Component({
  selector: 'app-modal-riscos-chaves-importarcao',
  templateUrl: 'modal-riscos-chaves-importacao.component.html',
  styleUrls: ['modal-riscos-chaves-importacao.component.scss']
})
export class ModalRiscosChavesImportacaoComponent implements OnInit{
  private currentDialogRef: MatDialogRef<any>;

  unidadeGestoraId: number;
  tipoUniversoId: number;
  criterioAvaliacaoId: number;
  constructor(
    private dialogRef: MatDialogRef<ModalRiscosChavesImportacaoComponent>,
    private matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any ,
    private router: Router,
  ) {


  }
  ngOnInit(): void {
   this.unidadeGestoraId = this.data.unidadeGestoraId;
   this.tipoUniversoId   = this.data.tipoUniversoId;
   this.criterioAvaliacaoId   = this.data.criterioAvaliacaoId;
  }
  public Sim(){
    this.dialogRef.close();
    this.router.navigate(['/importar-arquivo-riscos-chaves/novo'], { queryParams: { unidadeGestoraId: this.unidadeGestoraId, tipoUniversoId: this.tipoUniversoId, criterioAvaliacaoId: this.criterioAvaliacaoId } });
  }
  public Nao() {
    this.dialogRef.close();
  }
  public cancelar() {
    this.dialogRef.close();
  }

}
